import { EVENTS_PREFIX } from "core/config";
import { _WINDOW_ } from "constants/dom";
import { coreLogger } from "helpers/logger";
import integrationSettings from "core/integrationSettings";
import dispatchJSEvent from "helpers/dispatchJSEvent";
import isArray from "helpers/isArray";

export const EVENT_NAME = `${EVENTS_PREFIX}_tcf_init`;

const dispatchTCFInitializedEvent = () => {
  coreLogger("Init");
  // dispach custom JS event
  dispatchJSEvent(EVENT_NAME);

  // dispatch event to TagManager
  const { dataLayer } = integrationSettings;
  const dl = _WINDOW_[dataLayer] as Array<unknown> | undefined;
  if (isArray(dl)) {
    dl.push({ event: EVENT_NAME });
  }
};

export default dispatchTCFInitializedEvent;
